import { CheckboxChangeEventArgs as CheckboxChangeEventArgs_internal } from "./CheckboxChangeEventArgs";
import { ensureBool } from "igniteui-react-core";
var IgrCheckboxChangeEventArgs = /** @class */ /*@__PURE__*/ (function () {
    function IgrCheckboxChangeEventArgs() {
        this._implementation = this.createImplementation();
        this._implementation.externalObject = this;
        this.onImplementationCreated();
    }
    IgrCheckboxChangeEventArgs.prototype.createImplementation = function () {
        return new CheckboxChangeEventArgs_internal();
    };
    Object.defineProperty(IgrCheckboxChangeEventArgs.prototype, "i", {
        /**
         * @hidden
         */
        get: function () {
            return this._implementation;
        },
        enumerable: true,
        configurable: true
    });
    IgrCheckboxChangeEventArgs.prototype.onImplementationCreated = function () {
    };
    IgrCheckboxChangeEventArgs.prototype._provideImplementation = function (i) {
        this._implementation = i;
        this._implementation.externalObject = this;
        this.onImplementationCreated();
    };
    Object.defineProperty(IgrCheckboxChangeEventArgs.prototype, "isChecked", {
        get: function () {
            return this.i.isChecked;
        },
        set: function (v) {
            this.i.isChecked = ensureBool(v);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrCheckboxChangeEventArgs.prototype, "isIndeterminate", {
        get: function () {
            return this.i.isIndeterminate;
        },
        set: function (v) {
            this.i.isIndeterminate = ensureBool(v);
        },
        enumerable: true,
        configurable: true
    });
    return IgrCheckboxChangeEventArgs;
}());
export { IgrCheckboxChangeEventArgs };
//# sourceMappingURL=igr-checkbox-change-event-args.js.map
